export class DashboardMockups {

    static form1 = {
        'title': 'Symptoms Tracking Survey',
        'buttonDescription': 'Start Tracking my Symptoms',
        'buttonLink': '#',
        'history': [
            {
                'title': 'Survey',
                'date': '10/10/2016'
            },
            {
                'title': 'Survey',
                'date': '10/09/2016'
            }
        ]
    };

    static form2 = {
        'title': 'Distress Screner',
        'buttonDescription': 'Start Distress Screener Survey',
        'buttonLink': '#',
        'history': [
            {
                'title': 'Survey',
                'date': '05/10/2016'
            }
        ]
    };

    static form3 = {
        'title': 'Longitudinal test',
        'buttonDescription': 'Start Longitudinal test Survey',
        'buttonLink': '#',
        'history': [
            {
                'title': 'Survey',
                'date': '08/10/2016'
            }
        ]
    };

    static newForm1 = {
        'id': 999,
        'name': 'Patient Registry',
        'statusInstance': 'IN_PROGRESS'
    };

    static blog1 = {
        'id': '45',
        'name': 'Blog 12',
        'description': 'https://www.youtube.com/watch?v=HsOll65Wseg',
        'publishDate': [
            '2017',
            '10',
            '3'
        ]
    };

    static blog2 = {
        'id': '46',
        'name': 'Blog 13',
        'description': 'Fact Sheets',
        'publishDate': [
            '2017',
            '10',
            '3'
        ]
    };

    static formsArrayBE = [
        DashboardMockups.newForm1,
        DashboardMockups.newForm1,
        DashboardMockups.newForm1
    ];

    static blogsArrayBE = [
        DashboardMockups.blog1,
        DashboardMockups.blog2
    ];
}
